import axios from "axios";
import constant from "./constant";

const token = JSON.parse(localStorage.getItem("authUser"))?.token;



const axiosInstance = axios.create({
  baseURL: `${constant.appBaseUrl}/api/`,
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authUser"))?.token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  response=>response,
  error=>{
    if(error.response?.status===401){
      localStorage.removeItem("authUser");
      localStorage.removeItem("isLocked");
      if(window.location.pathname!=="/login"){
        window.location.replace("/login");
      }
      return Promise.reject(error);
    }
    return Promise.reject(
      error.response?.data || error
    );
  }
);
export const getUsersApi = async (params) => {
  try {
    const res = await axiosInstance.get("/adminWork/users", {
      params,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const getManagersApi = async (params) => {
  try {
    const res = await axiosInstance.get("/adminWork/Master-users", {
      params,
    });
    return res.data;
  } catch (error) {
    throw error;
  }
};


export const updateUserApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(
      `/team-ops/update-user/${id}`,
      data
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const resetUserPasswordApi = async (id, data) => {
  try {
    const res = await axiosInstance.put(
      `/adminWork/reset-password/${id}`,
      data
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const setReportingManagerApi = async (userId, data) => {
  try {
    const res = await axiosInstance.put(
      `/adminWork/set-reporting-manager/${userId}`,
      data
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getEmployeeTreeApi = async (userId) => {
  try {
    const res = await axiosInstance.get(`/adminWork/employee-tree?userId=${userId}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const userWithLeads = async (userId) => {
  try {
    const res = await axiosInstance.get(`/adminWork/userWithLeads`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getEligibleManagersApi = async ( userId ) => {
  try {
    const res = await axiosInstance.get( `/adminWork/eligible-reporting-managers/${userId}` );
    return res.data;
  } catch (error) {
    throw error;
  }
};
export const loginAlterationApi = async (userId, data) => {
  try {
    const res = await axiosInstance.post(`/adminWork/login-alteration/${userId}`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const getMyTeamApi = async (params) => {
  try {
    const res = await axiosInstance.get("/team-ops/my-team", { params });
    return res.data;
  } catch (error) {
    throw error;
  }
};

export default axiosInstance;